var _path, _mask, _g, _circle, _circle2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 100,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105 49.99C105 74.85 84.84 95 59.99 95c-9.72 0-18.7-3.08-26.05-8.31A45.615 45.615 0 0 1 28 81.63c-8.03-8.13-13-19.31-13-31.64C15 25.15 35.13 5 59.99 5 84.85 5 105 25.13 105 49.99z",
    fill: "#EFF0F1"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: -5,
    y: 5,
    width: 111,
    height: 91
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.003 49.99c0 24.86-20.16 45.01-45.01 45.01-9.72 0-48.64 2.73-55.99-2.5-2.13-1.52-1.17.35-3-1.5-8.03-8.13-5.5-28.68-5.5-41.01 0-24.84-10.5-44.99 64.49-44.99 24.86 0 45.01 20.13 45.01 44.99z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.875 82h-93.75C20.458 82 19 80.507 19 78.8V21.2c0-1.707 1.458-3.2 3.125-3.2h93.75c1.667 0 3.125 1.493 3.125 3.2v57.6c-.208 1.92-1.458 3.2-3.125 3.2z",
    fill: "#E9AF58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 55h-3v6h3v-6zm60 0h-3v6h3v-6zm-30 0h-3v6h3v-6zm-24 0h-3v6h3v-6zm60 0h-3v6h3v-6zm-30 0h-3v6h3v-6zm-24 0h-3v6h3v-6zm60 0h-3v6h3v-6zm-30 0h-3v6h3v-6zm-24 0h-3v6h3v-6zm30 0h-3v6h3v-6z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 76H89c-.6 0-1-.4-1-1v-8c0-.6.4-1 1-1h14c.6 0 1 .4 1 1v8c-.2.6-.6 1-1 1z",
    fill: "#DE6A5A"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 34,
    r: 9,
    fill: "#CD5747"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 34,
    r: 9,
    fill: "#5AB2AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 41.484c2.412-1.614 4-4.364 4-7.484s-1.588-5.87-4-7.485A8.993 8.993 0 0 0 37 34a8.99 8.99 0 0 0 4 7.484z",
    fill: "#1F2225"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.4465cd7232530bbfd8e370e24a160776.svg";
export { ForwardRef as ReactComponent };